import * as helpers from './helpers'
import template from './template'

export default {
  ...template,
  micro: {
    fontSize: helpers.pxToRem(12),
    lineHeight: 1.333
  },
  body: {
    xs: {
      fontSize: helpers.pxToRem(13),
      lineHeight: 16 / 13
    },
    s: {
      fontSize: helpers.pxToRem(14),
      lineHeight: 20 / 14
    },
    // Intermediate step between `s` (14px) and `m` (16px). Used today
    // by the action-button `m` size; available for other surfaces that
    // need a slightly larger-than-body-s tap target without jumping to
    // the full 16px body-m.
    sm: {
      fontSize: helpers.pxToRem(15),
      lineHeight: 20 / 15
    },
    m: {
      fontSize: helpers.pxToRem(16),
      lineHeight: 24 / 16
    },
    l: {
      fontSize: helpers.pxToRem(18),
      lineHeight: 24 / 18
    }
  },
  label: {
    s: {
      fontSize: helpers.pxToRem(14),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-0.42px'
    },
    m: {
      fontSize: helpers.pxToRem(16),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-0.48px'
    },
    l: {
      fontSize: helpers.pxToRem(18),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-0.54px'
    }
  },
  heading: {
    h1: {
      fontSize: helpers.pxToRem(60),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-1.8px',
      '@media (max-width: 768px)': {
        fontSize: '2.75rem' // 44px equivalent
      }
    },
    h2: {
      fontSize: helpers.pxToRem(32),
      lineHeight: 40 / 32
    },
    h3: {
      fontSize: helpers.pxToRem(24),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-0.72px'
    },
    h4: {
      fontSize: helpers.pxToRem(24),
      lineHeight: 1,
      fontWeight: 600,
      letterSpacing: '-0.72px'
    },
    h5: {
      fontSize: helpers.pxToRem(20),
      lineHeight: 1.3,
      fontWeight: 400
    },
    // MT.3 — small bold title used on card variants (e.g. PromotedGeneric).
    // body.m has 1.5 line-height/no letter-spacing which feels slack on
    // bold copy; this token tightens both for a cleaner heading rhythm.
    h6: {
      fontSize: helpers.pxToRem(16),
      lineHeight: 1.3,
      fontWeight: 700,
      letterSpacing: '-0.32px'
    }
  },
  weight: {
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extra: 800
  }
}
